import { render, staticRenderFns } from "./financialplanningtips.vue?vue&type=template&id=25c9a2da&scoped=true&"
import script from "./financialplanningtips.vue?vue&type=script&lang=js&"
export * from "./financialplanningtips.vue?vue&type=script&lang=js&"
import style0 from "./financialplanningtips.vue?vue&type=style&index=0&id=25c9a2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9a2da",
  null
  
)

export default component.exports